<template>
  <div class="t">
    <div class="top-flex" @click="gotoIndex">
      <div class="top">
        <img src="@/assets/home/logo.png" class="icon icon-l" />
        <h1>炎麟文化</h1>
      </div>
      <img src="@/assets/home/syc.png" class="icon" @click="toS" />
    </div>
    <div class="font">
      本站所有测试<span class="red">仅为娱乐测试，切勿深信。</span> >
      <span class="blue"><a href="./articleList/txt.html">免责声明</a></span>
    </div>
    <div class="coll">
      当前位置：
      <div style="display:flex">
        <div v-for="(item, index) in rout" :key="index" @click="goto(item)">
          <template v-if="index != rout.length - 1">{{ item.name }}/ </template>
          <h1 v-else>{{ item.name }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rout: [],
  },
  created() {
    console.log(this.$router.match, 123);
  },
  methods: {
    goto(item) {
      if (!item.path) return;
      let path = this.$route.path;
      if (path == item.path) return;
      this.$router.push(item.path);
    },
    gotoIndex() {
      let path = "/home";
      if (path == this.$route.path) return;
      this.$router.push(path);
    },
    toS() {
      window.location = "/h5/articleList/sitemap.html";
    },
  },
};
</script>
<style scoped>
.t {
  width: 100%;
}
.top-flex {
  display: flex;
  justify-content: space-between;
  color: #fff;
  width: 100%;
  padding: 0.1rem 0.2rem;
  box-sizing: border-box;
  font-size: 0.35rem;
  background: #4fd9d5;
}
.top {
  display: flex;
  align-items: center;
}
h1 {
  font-size: 0.35rem;
  font-weight: normal;
}
.coll h1 {
  font-size: 0.3rem;
  color: #666;
}
.icon {
  width: 0.6rem;
  height: 0.6rem;
  display: block;
}
.icon-l {
  margin-right: 0.2rem;
}
.font {
  background: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.1rem;
}
.red {
  color: red;
}
.blue {
  color: blue;
}
.coll {
  background: #eff5fb;
  padding: 0.1rem 0.2rem;
  color: #a1a1a1;
  font-size: 0.3rem;
  display: flex;
}
.coll {
  color: #666;
}
</style>
